import { RECEIVE_PRODUCT_TYPE } from '../constants/productType';

const initialState = [];

const reducer = function productTypeReducer(state = initialState, action) {
	const newState = { ...state };
	switch (action.type) {
		case RECEIVE_PRODUCT_TYPE:
			// if (action.response.result.length === 0) {
			//   return newState;
			// }
			const productTypes = action.response.result;
			return productTypes;
		default:
			return state;
	}
};

export default reducer;
